import {
    type GetSentNotificationByIdResponseType,
    type GetSentNotificationByIdRequestType
} from "./type";
import {
    request
} from "../request";

const getSentNotificationById = async (
    params: GetSentNotificationByIdRequestType
): Promise<GetSentNotificationByIdResponseType> => {
    return await request<GetSentNotificationByIdResponseType>(
        `/notification/getSentNotificationById?id=${params.id}`,
        {
            method: "GET"
        }
    );
};
export default getSentNotificationById;
